import englishMessages from "ra-language-english";
const shared = {
  id: "ID",
  name: "Name",
  login: "Login",
  created_at: "Created at",
  updated_at: "Updated at",
  status: "Status",
  merchant_id: "Merchant",
  config: "Config",
  url: "Show",
  mimetype: "File Type",
  gas_brand_id: "Gas Brand",
};

const en = {
  ...englishMessages,
  login: { required: "Please log in" },
  buttons: {
    delete: "Delete",
    edit: "Edit",
    close_editing: "Close editing",
    bulk_update_save: "Save",
    bulk_update_cancel: "Cancel",
  },

  directions: {
    center: "Center",
    top: "Top",
    bottom: "Bottom",
    left: "Left",
    right: "Right",
  },
  resizeMode: {
    cover: "Cover",
    contain: "Contain",
    stretch: "Stretch",
    repeat: "Repeat",
    center: "Center",
  },
  objectFit: {
    cover: "Cover",
    contain: "Contain",
    fill: "Fill",
    scaleDown: "Scale-down",
  },
  fontStyle: {
    normal: "Normal",
    italic: "Italic",
  },
  alignItems: {
    center: "Center",
    "flex-start": "Top",
    "flex-end": "Bottom",
  },
  justifyContent: {
    center: "Center",
    "flex-start": "Left",
    "flex-end": "Right",
  },
  textAlign: {
    center: "Center",
    start: "Left",
    end: "Right",
  },
  resources: {
    Dashboard: {
      name: "Dashboard",
      skip: "Skip",
    },
    PushNotificationService: {
      name: "Push Notification Services",
      notificationHeader: "Notification Header",
      notificationMessage: "Notification Message",
      fields: {
        ...shared,
        config: {
          name: "Config",
          app_id: "App ID",
          token: "Token",
        },
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
          blocked: "blocked",
          error: "error",
        },
        send: "Send",
        sendTitle: "Send Push-notification",
        selectPhoto: "Choose photo",
        preview: "Preview :",
        toWhomToSend: "To whom to send :",
        singleUser: "Single user",
        allUsers: "All users",
        categories: "Categories",
        selectUser: "Select user",
        selectTags: "Select tag",
        chooseCategory: "Choose a category",
        messageSentSuccessfully: "Message sent successfully",
        tags: "Tags",
        errorSelectCategory: "Please select a category",
        errorSelectTag: "Please select at least one tag",
        errorSelectUser: "Please select a user",
      },
    },
    EmailService: {
      name: "Email Services",
      fields: {
        ...shared,
        config: {
          name: "Config",
          api_key: "API key",
          service_id: "Service ID",
          template_id: "Template ID",
          user_id: "User ID",
          accessToken: "Access Token",
          api_key_public: "Public API Key",
          api_key_private: "Private API Key",
          token: "Token",
          email: "Email",
          app_name: "Mobile App name",
        },
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
          blocked: "blocked",
          error: "error",
        },
      },
    },
    AsyncJob: {
      name: "Async Jobs",
      fields: {
        ...shared,
        job_name: "Job name",
        next_run: "Next run",
        payload: "Payload",
        result: "Result",
        attempts_left: "Attempts left",
        retry_delay: "Retry delay",
      },
      source: {
        status: {
          scheduled: "scheduled",
          complete: "complete",
          failed: "failed",
          processing: "processing",
        },
      },
    },
    Coupon: {
      name: "Coupons",
      fields: {
        ...shared,
        id: "Coupon ID",
        coupon_code: "Coupon code",
        fuel_type: "Fuel type",
        nominal: "Nominal",
        client_id: "Client",
        trunc_id: "Trunc",
        valid_period: "Valid period",
        shared_at: "Shared at",
        reserved_until: "Reserved until",
        begin_date: "Valid period: start date",
        end_date: "Valid period: end date",
        coupon_serial: "Coupon serial",
        previous_state: "Previous status",
      },
      source: {
        status: {
          initial: "initial",
          active: "active",
          shared: "shared",
          expired: "expired",
          used: "used",
          locked: "locked",
          reserved: "reserved",
        },
        import_file: "Do you want to add one?",
        buttons: {
          import: "Import",
        },
      },
    },
    Total: {
      name: "Totals",
      fields: {
        total_sold_fuels: {
          name: "Total sold fuels",
          amount_sum: "Total sold fuels amount (l)",
          total_fuel_sum: "Total sold fuels sum (₴)",
        },
        total_topup: "Total topup (₴)",
        total_left_balance: "Total left balance (₴)",
        start_date: "Start date",
        end_date: "End date",
      },
    },
    QrCard: {
      name: "QR Сards",
      fields: {
        ...shared,
        card_owner: "Card owner ID",
        card_holder: "Card holder ID",
        begin_date: "Begin date",
        end_date: "End date",
        card_name: "Card name",
        balance: "Balance",
        phone: "Card holder phone",
        pin1: "Pin-code",
        is_archive: "Card status",
      },
      source: {
        fn_card_owner: "Card owner full name",
        card_owner: "Card owner",
        card_holder: "Card holder",
        status: {
          archive: "disabled",
          active: "active",
        },
      },
    },
    Trunc: {
      name: "Truncs",

      fields: {
        ...shared,
        merchant_payment_gateway_id: "Merchant Payment Gateway",
        client_id: "Client",
        description: "Description",
        short_description: "Short description",
        amount: "Amount(UA)",
        transactions: "Transactions",
        client_phone: "Client's phone",
        title: "Title",
        start_date: "Start date",
        end_date: "End date",
        webhook_service_name: "Web hook service",
        payload: "Payload",
        order_id: "Order ID",
        coupon_id: "Fuel type",
        amount_nominal: "Amount of nominal",
        datex_id: "Datex ID",
        session_id: "Session ID",
      },
      source: {
        finishPayment: "Finish payment",
        info: "Info",
        succeed: "Payment succeeded",
        webhook_service_name: {
          topupDatex: "Topup Datex",
          sellCouponFromStock: "Buy Coupons",
          preSellCouponFromStock: "Booking Coupons",
        },
      },
    },
    DatexTransaction: {
      name: "Transactions",
      fields: {
        fn_card_owner: "Card owner full name",
        amount: "Amount",
        amount_ok: "Amount",
        sum: "Sum",
        sum_ok: "Sum",
        n_account: "Fuel type",
        n_accounts_struc: "Fuel type",
        n_service_station: "Service station",
        address: "Address",
        n_issuers: "Issuers",
        confirm_status: "Confirm status",
        session_time: "Session time",
        code_edroup_card_owner: "Card owner code EDROUP",
        is_passed: "Status",
        serial_visible: "Serial Visible",
        card_id: "Card ID",
      },
    },
    Promotion: {
      name: "Promotion",
      fields: {
        ...shared,
        file_id: "File",
        title: "Title",
        text: "Text",
      },
      source: {
        status: {
          scheduled: "scheduled",
          active: "active",
          finished: "finished",
          blocked: "blocked",
        },
      },
    },
    PaymentGateway: {
      name: "Payment Gateway",
      fields: {
        ...shared,
      },
    },
    MerchantPaymentGateway: {
      name: "Merchant Payment Gateway",
      fields: {
        ...shared,
        default: "Set as Default",
        payment_gateway_id: "Payment Gateway",
        logo_file_id: "Logo",
      },
    },
    Design: {
      name: "Design",
      fields: {
        ...shared,
        default_page_id: "Default page",
        error_page_id: "Error page",
        authenticated_page_id: "Authenticated page",
        loader_page_id: "Loader page",
        styles: {
          backgroundColor: "Background color",
          color: "Text color",
          borderColor: "Border color",
          justifyContent: "Horizontal alignment",
          alignItems: "Vertical alignment",
        },
      },
    },
    Page: {
      name: "Page",
      fields: {
        ...shared,
        design_id: "Design",
        styles: {
          backgroundColor: "Background color",
          color: "Text color",
          justifyContent: "Horizontal alignment",
          alignItems: "Vertical alignment",
        },
      },
      source: {
        tab: {
          basic: "Basic",
          preview: "Preview",
        },
      },
    },
    Block: {
      name: "Block",
      fields: {
        ...shared,
        type: "Type",
        position: "Position",
        blocks: "Blocks",
        container_styles: {
          backgroundColor: "Background color",
          alignItems: "Align items",
          justifyContent: "Justify content",
        },
        styles: {
          textAlignVertical: "Vertical text alignment",
          textAlign: "Text alignment",
          backgroundColor: "Background color",
          color: "Color",
          borderWidth: "Border width",
          width: "Width %",
          height: "Height %",
          borderRadius: "Border radius",
          fontSize: "Font size",
          fontWeight: "Font weight",
          alignItems: "Align Items",
          fontStyle: "Font style",
          placeholderTextColor: "Placeholder text color",
          objectFit: "Object fit",
          borderColor: "Border color",
          resizeMode: "Resize mode",
        },
        props: {
          text: "Text",
          action: "Action",
          redirect_page_id: "Redirect on click",
          uri: "Image",
          file_id: "File",
        },
      },
      source: {
        type: {
          Button: "Button",
          EmptyBlock: "Empty block",
          Image: "Image",
          PhoneInput: "Phone input",
          Text: "Text",
          TextInput: "Text input",
        },
        tab: {
          basic: "Basic",
          containerStyles: "Container styles",
          blockProps: "Block props",
        },
      },
    },
    File: {
      name: "Files",
      fields: {
        ...shared,
        attachments: "Attachments",
        size: "Size (MB)",
        link: "Link",
      },
      source: {
        mimetype: {
          "image/webp": "WEBP",
          "image/png": "PNG",
          "image/svg+xml": "SVG",
          "application/pdf": "PDF",
        },
      },
    },
    Merchant: {
      name: "Merchant",
      fields: {
        ...shared,
        current_password: "Current password",
        new_password: "New password",
        storage_capacity: "File storage capacity (MB)",
        design_id: "Design",
        newbie: "Newbie",
      },
      source: {
        status: {
          active: "active",
          inactive: "inactive",
          disabled: "disabled",
          blocked: "blocked",
          error: "error",
        },
      },
    },
    Chat: {
      name: "Chats",
      fields: {
        ...shared,
        input: {
          placeholder: "Type your message",
        },
      },
    },
    Brand: {
      name: "Brand",
      fields: {
        ...shared,
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
          blocked: "blocked",
          error: "error",
        },
        tab: {
          basic: "Basic",
          confirm_changes: "Confirm changes",
        },
      },
    },
    BrandMerchant: {
      name: "Brand Merchants",
      fields: {
        ...shared,
        id: "Brand Merchant ID",
        brand_id: "Brand",
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
        },
      },
    },
    GasBrandMerchant: {
      name: "Gas Brand Merchant",
      fields: {
        ...shared,
        fuels: "Fuels",
        coordinates: "AZS Coordinates",
        priority: "Priority",
        logo_file_id: "Logo",
        partner_gas_brand: "Partner Gas Brand",
        qr_type: "Qr Type",
      },
      fuels: {
        name: "Fuel type",
        alias_fuel_type: "Fuel type(ua)",
        regular_price: "Regular price (in kop.)",
        discount_price: "Discount price (in kop.)",
        stella_price: "Average price by gas station (in kop.)",
        coupon_price: "Online coupon price (in kop.)",
        status: "Status",
      },
      coordinates: {
        address: "Address",
        lat: "Latitude",
        long: "Longitude",
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
          blocked: "blocked",
        },
        no_value: "No logo",
        infoTab: {
          info: "General info",
          coords: "AZS Coordinates",
          fuels: "Fuels",
        },
      },
    },
    Client: {
      name: "Clients",
      fields: {
        ...shared,
        phone: "Phone",
        first_name: "First name",
        last_name: "Last name",
        middle_name: "Middle name",
        email: "Email",
        password: "Password",
        category_id: "Category",
        tag_ids: "Tags",
        city: "City",
        region: "Region",
        address: "Address",
        entity: "Client entity",
        balance: "Balance",
        car_number: "Car number",
        sex: {
          name: "Sex",
          female: "Female",
          male: "Male",
        },
        date_of_birth: "Date of birth",
        terms_agreement_confirm: "Terms agreement confirm",
        unconfirmed_changes: {
          name: "Changes",
          field_name: "Field name",
          value: "Value",
          status: "Status",
        },
        has_changes: "Сhange request",
        mango_transactions: {
          fn_card_owner: "Card owner full name",
          amount_ok: "Amount",
          sum_ok: "Sum",
          n_accounts_struc: "Fuel type",
          n_service_station: "Service station",
          address: "Address",
          n_issuers: "Issuers",
          confirm_status: "Confirm status",
          session_time: "Session time",
        },
        mango_payment_transactions: {
          client_fn: "Card owner full name",
          s_docums: "Amount",
          payment_note: "Payment description",
          status: "Status",
          session_time: "Session time",
        },
        mango_cards: {
          card_owner: "Card owner ID",
          card_name: "Card name",
          phone: "Card holder phone",
        },
        petrolcard_transactions: {
          accountName: "Fuel type",
          cardId: "Card ID",
          serialVisible: "Serial visible",
          price: "Price",
          amount: "Amount",
          sum: "Sum",
          politicsDiscountId: "Politics discount ID",
          discountValue: "Discount value",
          issuerName: "Issuer name",
          versionId: "Version ID",
          transactionId: "Transaction ID",
          tradePointName: "AZS branch name",
          transactionTime: "Transaction time",
          tradePointAddress: "AZS address",
          passed: "Status",
        },
        petrolcard_payment_transactions: {
          description: "Description",
          amount: "Amount(UA)",
          transactions: "Transactions",
          payload: "Payload",
          order_id: "Order ID",
        },
        petrolcard_cards: {
          cardId: "Card ID",
          serialVisible: "Serial visible",
          isActive: "Status",
          endDate: "End date",
          cardType: "Card type",
          cardDiscountsConf: {
            cardDiscountsConfName: "Card discounts config name",
          },
          terminalGroups: {
            name: "Terminal groups",
            terminalGroupName: "Terminal group name",
          },
          cardIssuers: {
            name: "Card issuers",
            cardIssuersName: "Card issuers name",
          },
        },
        deleted_at: {
          title: "Delete client",
          true: "Delete",
          false: "Restore",
        },
      },
      source: {
        status: {
          initial: "initial",
          active: "active",
          confirmed: "confirmed",
          disabled: "disabled",
          blocked: "blocked",
        },
        changes_status: {
          pending: "pending",
          confirmed: "confirmed",
          rejected: "rejected",
        },
        payment_status: {
          1: "success",
        },
        unconfirmed_changes_fields: {
          field_name: "Field name",
          value: "Value",
          status: "Status",
        },
        tab: {
          basic: "Basic",
          confirm_changes: "Confirm changes",
        },
        infoTab: {
          info: "Client Info",
          transactions: "Transactions",
          payment_transactions: "Topup",
          cards: "Cards",
        },
        entity: {
          physical: "Physical entity",
          legal: "Legal entity",
        },
        deleted: "Deleted at",
        search: "First or Last name",
        blocked_at: "Blocked at",
      },
    },
    SmsService: {
      name: "Sms Services",
      fields: {
        ...shared,
        service_name: "Service name",
        config: {
          name: "Config",
          key: "API key",
          sender: "Sender",
        },
        balance: "Balance",
      },
      source: {
        status: {
          active: "active",
          disabled: "disabled",
          blocked: "blocked",
          error: "error",
        },
      },
    },
    Category: {
      name: "Categories",
      fields: {
        ...shared,
        name: "Name",
      },
    },
    Tag: {
      name: "Tags",
      fields: {
        ...shared,
      },
    },
    Coordinate: {
      name: "Coordinate",
      fields: {
        ...shared,
        fuel_types_as_object: "Fuel types",
        address: "Address",
        lat: "Latitude",
        long: "Longitude",
      },
    },
    notifications: {
      errors: {
        Forbidden: "An error has occured",
        delete_error: "Element can not be deleted!",
        already_exist: "Element already exists!",
        name_of_fuel_already_exist: "Fuel already exists!",
        dublicate_name_of_fuel_update: "Entered duplicate fuel names",
        page_set_as_default:
          "Page is set as design's default, remove it from there before performing deletion",
        oversize: "File size shouldn't exceed 10MB",
        min_length: "Password should be at least 4 characters long",
        max_length: "Password should be at less then 10 characters",
        not_match: "Current password does not match",
        password_required: "Password is required!",
        current_required: "Current password is required!",
        invalid_phone_format:
          "Invalid phone format, it should start with 380 and not include + sign",
        invalid_email_format: "Invalid email format",
        no_free_space:
          "No free space left, please delete some files before upload",
        forbidden_filetype:
          "Filetype not supported, allowed file extentions: .png, .svg, .webp, .pdf",
        invalid_syntax: "Element doesn't follow the required syntax",
        pin_invalid_syntax: "Pin-code doesn't follow the required syntax",
        file_in_use: "Cannot delete file currently in use",
        default_not_found: "Default payment gateway already choosen",
        password_is_required: "Password is required",
        can_not_edit: "Can't update with status blocked",
        can_not_edit_parent: "Can't update, parent element with status blocked",
        is_not_avilable: "Choosen element is not avilable",
        invalid_date: "Invalid date format",
        missing_terms_agreement_confirm:
          "Terms agreement confirm is a required field",
        async_job_not_found: "Async job is not found",
        plugin_inactive: "Plugin '%{resource}' not active",
        datex_error:
          "Failed to load page. Please, check config for brand merchant 'Datex'",
        empty: "Cannot be empty",
        empty_config:
          "Selected Merchant Payment Gateway Config is empty, please fill it in",
        no_record: "No records match the filters",
      },
      success: "Changes saved successfully",
      no_available: "No'%{resource}' yet",
      confirm: {
        delete: "Are you sure you want to delete this item?",
      },
    },
  },
};

export default en;
